import { useRoleContentParser } from 'pages/Opportunities/components/OpportunitiesContent/ProjectItem/RoleItem/RoleContent/useHeaderContentParser';
import React from 'react';
import RoleItem from './RoleItem';
import {
  InfoWrapper,
  Label,
  PublicRoleCont,
  RoleTitle,
  Description,
  GridWrapper,
  MediaCont,
  MediaWrapper,
  RoleHeader,
  ButtonCont,
  ContentWrapper,
  SharedCont,
} from './PublicRole.styles';
import { Button, Grid, IconButton, Popover, Tooltip, useTheme } from '@material-ui/core';
import MediaItem from 'pages/Opportunities/components/OpportunitiesContent/ProjectItem/MediaItems/MediaItem';
import { customSort } from 'shared/interfaces/utils/IMediaFileType';
import { LuShare2 } from 'react-icons/lu';
import { COLORS } from 'shared/constants/COLORS';
import { CONFIG } from 'shared/config';
import { CheckMarkIcon } from '@room-match/shared-ui-components';
import { CustomTypography } from 'shared/elements/CustomTypography';
import { useContextSelector } from 'use-context-selector';
import { OpportunitiesContext } from 'pages/Opportunities/context/OpportunitiesContext';
import ProjectLoaders from 'pages/Opportunities/components/OpportunitiesContent/Loaders/ProjectLoaders';
import LinkItem from 'shared/components/LinkItem/LinkItem';
import LinkItemLite from 'shared/components/LinkItem/LinkItemLite';
import { ICastingRoleAttributes } from 'shared/interfaces/ICastingRole';
import { IMediumAttributes } from 'shared/interfaces/IMedium';

interface Props {
  roleId: string;
  projectId: string;
  companyName: string;
  projectName: string;
  shared?: boolean;
  castingRole?: ICastingRoleAttributes;
}

const RoleWithinProject: React.FC<Props> = ({ roleId, projectId, companyName, projectName, shared, castingRole }) => {
  const isDark = useTheme().palette.type === 'dark';
  const applyToRole = useContextSelector(OpportunitiesContext, (v) => v.applyToRole);
  const openOpportunityModal = useContextSelector(OpportunitiesContext, (v) => v.openOpportunityModal);
  const {
    roleMedia,
    wardrobeNote,
    auditionNote,
    roleLoading,
    ageType,
    roleName,
    union,
    rate,
    submitBy,
    talentSubmitBy,
    work,
    fittingDate,
    age,
    gender,
    ethnicities,
    location,
    roleDescription,
    roleMediaCount,
    workingNote,
    ethnic_appearance,
    genders,
    links,
  } = useRoleContentParser(roleId, true, castingRole);

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

  const open = Boolean(anchorEl);
  const handleClose = () => {
    setAnchorEl(null);
  };
  const copyLink = (event: React.MouseEvent<HTMLButtonElement>) => {
    // if (anchorEl !== null) return;
    // //copy to clipboard
    // navigator.clipboard.writeText(`${CONFIG.JOBS_APP_URL}/${projectId}/${roleId}`);
    // setAnchorEl(event.currentTarget);
    // setTimeout(() => {
    //   handleClose();
    // }, 1500);
    openOpportunityModal('share', `${CONFIG.JOBS_APP_URL}/${projectId}/${roleId}`, projectName, roleName);
  };

  const handleApply = () => {
    applyToRole(roleId, projectId, companyName, roleName);
  };

  if (roleLoading) return <ProjectLoaders />;
  return (
    <PublicRoleCont
      style={{
        ...(castingRole && {
          padding: 20,
          background: isDark ? COLORS.DARK_GRAY : COLORS.LIGHT_BACKGROUND,
          borderTop: 'none',
          borderRadius: 8,
        }),
      }}
      shared={+Boolean(shared)}
    >
      {shared ? (
        <SharedCont>
          <CustomTypography fontSize={12} fontWeight={700} color="white">
            ROLE SHARED WITH YOU
          </CustomTypography>
        </SharedCont>
      ) : (
        <React.Fragment />
      )}
      <RoleHeader>
        <RoleTitle> {castingRole ? roleName : `Role: ${roleName}`}</RoleTitle>
        {castingRole ? null : (
          <ButtonCont>
            <IconButton style={{ padding: 5 }} onClick={copyLink}>
              <LuShare2 color={COLORS.PRIMARY} />
            </IconButton>

            <Button
              variant="contained"
              color="primary"
              style={{ fontWeight: 600, height: 35, alignSelf: 'center' }}
              onClick={handleApply}
            >
              Submit
            </Button>
          </ButtonCont>
        )}
      </RoleHeader>
      <ContentWrapper>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 20, flex: 1 }}>
          <GridWrapper>
            <Grid container spacing={3}>
              <Grid item xs={12} lg={4} md={6}>
                <Label fontWeight={500}>Submit By</Label>
                <Description>{talentSubmitBy || submitBy}</Description>
              </Grid>
              <Grid item xs={12} lg={4} md={6}>
                <Label fontWeight={500}>Age</Label>
                <Description>{age}</Description>
              </Grid>
              <Grid item xs={12} lg={4} md={6}>
                <Label fontWeight={500}>Rate</Label>
                <Description>{rate}</Description>
              </Grid>
              <Grid item xs={12} lg={4} md={6}>
                <Label fontWeight={500}>Work</Label>
                <Description>{work}</Description>
              </Grid>
              <Grid item xs={12} lg={4} md={6}>
                <Label fontWeight={500}>Gender</Label>
                <Description>{gender}</Description>
              </Grid>
              {/* 
              <Grid item xs={12} lg={4} md={6}>
                <Label fontWeight={500}>Fitting</Label>
                <Description>{fittingDate}</Description>
              </Grid> */}

              <Grid item xs={12} lg={4} md={6}>
                <Label fontWeight={500}>Ethnicity</Label>
                <Tooltip title={castingRole?.ethnic_appearance?.join(', ') || '-'}>
                  <div>
                    <Description>{ethnicities}</Description>
                  </div>
                </Tooltip>
              </Grid>

              <Grid item xs={12} lg={4} md={6}>
                <Label fontWeight={500}>Location</Label>
                <Description>{location}</Description>
              </Grid>
            </Grid>
          </GridWrapper>
          <InfoWrapper>
            <Label>Description</Label>
            <Description>{roleDescription}</Description>
          </InfoWrapper>
          {/* <InfoWrapper>
            <Label>Working Notes</Label>
            <Description>{workingNote}</Description>
          </InfoWrapper>
          <InfoWrapper>
            <Label>Audition Note</Label>
            <Description>{auditionNote}</Description>
          </InfoWrapper>
          <InfoWrapper>
            <Label>Wardrobe Note</Label>
            <Description>{wardrobeNote}</Description>
          </InfoWrapper> */}
          {open ? (
            <Popover
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
              open={open}
            >
              <div style={{ padding: 10, display: 'flex', gap: 5, alignItems: 'center' }}>
                <CheckMarkIcon htmlColor={COLORS.SUCCESS} fontSize="small" />
                <CustomTypography fontSize={14} style={{ color: COLORS.SUCCESS }} fontWeight={700}>
                  Link Copied!
                </CustomTypography>
              </div>
            </Popover>
          ) : null}
        </div>
        <MediaWrapper>
          <Label>Media Reference</Label>
          <MediaCont>
            {(roleMedia as Array<IMediumAttributes>)
              ?.sort(customSort)
              .map((m) => <MediaItem key={m.id} file={m as IMediumAttributes} />)}
            {links.length > 0 ? links.map((link, idx) => <LinkItemLite key={idx} url={link} />) : <React.Fragment />}
          </MediaCont>
        </MediaWrapper>
      </ContentWrapper>
    </PublicRoleCont>
  );
};

export default RoleWithinProject;
